import { BaseCRUD } from '@/services/base-request';
import { toastError } from '@/composables/toast';

const serviceName = 'catalogs';

export class CatalogService {
    /**
     * @param {number} offset
     * @param {number} limit
     * @returns {Promise<Response>}
     */
    static async getCountryList (offset, limit) {
        const resp = await BaseCRUD.GET({
            service: serviceName,
            entity: 'country',
            query: {
                offset,
                limit,
            },
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.payload;
    };

    /**
     * @param {number} offset
     * @param {number} limit
     * @returns {Promise<Response>}
     */
    static async getCurrenciesList (offset, limit) {
        const resp = await BaseCRUD.GET({
            service: serviceName,
            entity: 'currency',
            query: {
                offset,
                limit,
            },
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.payload;
    };

    /**
     * @param {Object} body
     * @param {string} body.code
     * @returns {Promise<Response>}
     */
    static async addNewCurrency (body) {
        const resp = await BaseCRUD.PUT({
            service: serviceName,
            entity: 'currency',
            body,
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.status.ok;
    }

    /**
     * @param {string} code
     * @returns {Promise<Response>}
     */
    static async removeCurrency (code) {
        const resp = await BaseCRUD.DELETE({
            service: serviceName,
            entity: 'currency',
            id: code,
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.payload;
    }

    /**
     * @param {string} code
     * @param {boolean} isVisible
     * @returns {Promise<Response>}
     */
    static async changeCurrencyVisibility ({ code, isVisible }) {
        const resp = await BaseCRUD.PATCH({
            service: serviceName,
            entity: `currency`,
            id: `${code}/visibility`,
            body: {
                isVisible,
            },
        });

        if (!resp.status.ok) {
            toastError('serverError');
            return null;
        }
        return resp.status.ok;
    }
}
